import { Avatar, Col, Row } from "antd";
import React, { useEffect, useRef, useState } from "react";
import StyledContentCard from "../../components/styledComponent/styledContentCard";
import { useNavigate, useParams } from "react-router-dom";
import {
  getCustomerDetails,
  updateCustomer,
} from "../../server/customerServices";
import { ShowNotification } from "../../components/notification/notification";
import { AiOutlineUser } from "react-icons/ai";
import "./customerPage.css";
import { Capitalize } from "../../utils/utils";
import CustomerCreationModal from "./customerCreationModal";
import { useAppContext } from "../../contexts/appContext";
import { PRIMARY_THEME } from "../../constants/constant";
import { MdVerified } from "react-icons/md";

function CustomerDetails() {
  const { startLoading, stopLoading, user } = useAppContext();
  const { id } = useParams();
  const navigate = useNavigate();
  const formRef = useRef(null);

  const [customerData, setCustomerData] = useState();
  const [customerAddress, setCustomerAddress] = useState();
  const [showUpdate, setShowUpdate] = useState(false);
  const [refetch, setRefetch] = useState(false);
  var userRole = user?.role;
  var customerAccess = user?.access?.customer;
  const fetchCustomerDetails = async () => {
    startLoading();
    try {
      let res = await getCustomerDetails(id);
      if (!res.data) {
        ShowNotification({ type: "error", message: "Customer not Found" });
        navigate("/customer");
      } else {
        setCustomerData(res.data.customer);
        setCustomerAddress(res.data.address);
      }
      setRefetch(false);
    } catch (error) {
    } finally {
      stopLoading();
    }
  };
  useEffect(() => {
    fetchCustomerDetails();
  }, [refetch]);
  const ShowCustomerAddress = () => {
    const keysToExclude = [
      "created_at",
      "updated_at",
      "customer_id",
      "id",
      "latitude",
      "longitude",
    ];
    const filteredEntries = Object.entries(customerAddress || {}).filter(
      ([key]) => !keysToExclude.includes(key)
    );
    return filteredEntries.map(([key, value]) => (
      <Row key={key} className="mb-2">
        <Col span={24} className="details-key">
          {Capitalize(key)}:
        </Col>
        <Col span={24} className="details-value">
          {value ? Capitalize(value) : "-"}
        </Col>
      </Row>
    ));
  };
  const onClickEdit = () => {
    setShowUpdate(true);
  };
  const handleUpdateCustomer = (values) => {
    startLoading();
    updateCustomer(id, values)
      .then(() => {
        ShowNotification({
          type: "success",
          message: "Customer Updated Successfully",
        });
        setShowUpdate(false);
        setRefetch(true);
        formRef.current.resetFields();
      })
      .finally(() => {
        stopLoading();
      });
  };
  return (
    <div>
      {showUpdate && (
        <CustomerCreationModal
          showCreationModal={showUpdate}
          setShowCreationModal={setShowUpdate}
          formRef={formRef}
          updateId={id}
          setUpdateId={() => {}}
          onUpdate={handleUpdateCustomer}
        />
      )}
      <StyledContentCard
        title={"Customer Details"}
        showEdit={userRole === "Admin" || customerAccess?.edit}
        onClickEdit={onClickEdit}
      >
        <Row>
          <Col span={12}>
            <Row className="mb-2">
              <Col span={24}>
                <div className="details-key">Name:</div>
                <div className="details-value">
                  {customerData && customerData.name ? (
                    <div className="flex items-center gap-2">
                      {customerData.name}
                      {customerData.is_vip && (
                        <MdVerified size={18} color={PRIMARY_THEME} />
                      )}
                    </div>
                  ) : (
                    "-"
                  )}
                </div>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col span={24} className="details-key">
                Contact Number:
              </Col>
              <Col span={24} className="details-value">
                {customerData && customerData.contact_no
                  ? customerData.contact_no
                  : "-"}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col span={24} className="details-key">
                Email Id:
              </Col>
              <Col span={24} className="details-value">
                {customerData && customerData.email ? customerData.email : "-"}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col span={24} className="details-key">
                VIP Customer:
              </Col>
              <Col span={24} className="details-value">
                {customerData && customerData.is_vip ? "Yes" : "No"}
              </Col>
            </Row>
            <ShowCustomerAddress />
          </Col>
          <Col span={12} className="flex justify-center pt-5">
            <Avatar
              size={250}
              shape="square"
              icon={<AiOutlineUser />}
              style={{ backgroundColor: "#e9e9e9" }}
            />
          </Col>
        </Row>
      </StyledContentCard>
    </div>
  );
}

export default CustomerDetails;
